// extracted by mini-css-extract-plugin
export default {"needToKnow":"NeedToKnow_needToKnow__vefUC","needToKnow__content":"NeedToKnow_needToKnow__content__kph5l"};